// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1FaCf","box":"Header_box__+IhCG","logo":"Header_logo__LQrFF","button-box":"Header_button-box__5wVcl","info-icon":"Header_info-icon__3IezG"};